import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// Hard gate: when `age_verification_required` is ON, members who aren't Verified 18+
// can only reach /verify (and admins keep their tooling). Mirrors the backend age_gate.
const OPEN = ["/verify", "/admin"];

export default function VerifyRequiredGate({ children }) {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const [st, setSt] = useState(null);
  useEffect(() => {
    if (!user) return;
    api.get("/verify/status").then(({ data }) => setSt(data)).catch(() => {});
  }, [user, user?.age_verification_status, pathname]);
  if (!user || !st || !st.required || user.role === "admin" || st.status === "verified") return children;
  if (OPEN.some((p) => pathname.startsWith(p))) return children;
  return <Navigate to="/verify" replace state={{ gated: true }} />;
}
